import { render, staticRenderFns } from "./ProjectMember.vue?vue&type=template&id=ab329052&scoped=true"
import script from "./ProjectMember.vue?vue&type=script&lang=js"
export * from "./ProjectMember.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=ab329052&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab329052",
  null
  
)

export default component.exports